export default {
  brl(value) {
    const number = Number(value)
    const safeNumber = Number.isFinite(number) ? number : 0
    const hasCents = Math.round(Math.abs(safeNumber) * 100) % 100 !== 0

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: 2,
    }).format(safeNumber)
  },

  number(value, unity) {
    const number = Number(value)
    const safeNumber = Number.isFinite(number) ? number : 0

    const formatted = new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(safeNumber)

    return unity ? `${formatted} ${unity}` : formatted
  },
}
